import './theme.css'

import CodeMirror, {
  BasicSetupOptions,
  Extension,
  ReactCodeMirrorProps,
} from '@uiw/react-codemirror'
import React from 'react'

import { useDetectTheme } from '../hooks'
import { dittoDarkTheme, dittoLightTheme } from './themes'

export type SupportedEditorLanguage = 'typescript' | 'json' | string

export enum CodeEditorValidationSeverity {
  Hint = 1,
  Info = 2,
  Warning = 4,
  Error = 8,
}

export type CodeEditorValidationResult = {
  severity: CodeEditorValidationSeverity
  message: string
  startLineNumber: number
  endLineNumber: number
  startColumn?: number
}

export type CodeEditorV2Props = {
  /** The initial value for the editor */
  value?: string
  /** Callback for when the content changes */
  onChange?: (value: string) => void
  /** Height of the editor */
  height?: string
  /** Whether the editor is read-only */
  readOnly?: boolean
  /** Custom language extension for CodeMirror */
  language: Extension
  /** Linter function */
  linter?: Extension
  /** Options for basicSetup in CodeMirror (https://www.npmjs.com/package/@uiw/codemirror-extensions-basic-setup) */
  options?: BasicSetupOptions
} & Omit<ReactCodeMirrorProps, 'onChange' | 'value' | 'height' | 'readOnly'>

export default function CodeEditorV2({
  value,
  onChange,
  height = '300px',
  readOnly = false,
  language,
  linter,
  options,
  ...rest
}: CodeEditorV2Props) {
  return (
    <CodeMirror
      basicSetup={{ ...options }}
      value={value}
      onChange={onChange}
      height={height}
      readOnly={readOnly}
      theme={useDetectTheme() === 'dark' ? dittoDarkTheme : dittoLightTheme}
      extensions={[language, ...(linter ? [linter] : [])]}
      {...rest}
    />
  )
}
